import {getTemplates} from "../login/ClientCache";
import {translateId} from "./Translator";
import * as KeyboardKey from "../constants/KeyboardKeyCode";

/**
 *
 * @type {Map<String, String[]>}
 */
let registeredShortcuts = new Map();
/**
 *
 * @type {Map<String, String>}
 */
let reversedShortcuts = new Map();

export function registerShortcutKeys(shortCuts) {
    let templates = getTemplates();
    if (templates) {
        for (let templateMetadata of templates) {
            registerShortcut_(templateMetadata.shortcut, templateMetadata.template.id);
        }
    }
    if (!shortCuts || !shortCuts.details)
        return;
    for (let line of shortCuts.details) {
        registerShortCut(line.shortCut);
    }
}

function registerShortCut(shortCut) {
    if (!shortCut)
        return null;
    let keyboardShortcut = shortCut.shortCut;
    let id = shortCut.bizFunction;
    let eventKey = registerShortcut_(keyboardShortcut, id);
    return eventKey;
}

function registerShortcut_(keyboardShortcut, id) {
    if (!keyboardShortcut || !keyboardShortcut.theKey)
        return null;
    let eventKey = shortcutToEventKey(keyboardShortcut);
    if (!(registeredShortcuts.get(eventKey)))
        registeredShortcuts.set(eventKey, []);
    registeredShortcuts.get(eventKey).push(id);
    reversedShortcuts.set(id, keyboardShortcut);
    return eventKey;
}

function shortcutToEventKey(keyboardShortcut) {
    let key = keyboardShortcut.theKey;
    let ctrl = keyboardShortcut.useCtrl;
    let shift = keyboardShortcut.useShift;
    let alt = keyboardShortcut.useAlt;
    let eKey = eventKey(KeyboardKey[key], alt, ctrl, shift);
    return eKey;
}

function eventKey(key, alt, ctrl, shift) {
    return key + "_" + bToI(alt) + bToI(ctrl) + bToI(shift);
}

function bToI(b) {
    return b === true ? "1" : "0";
}

export function describe(shortCut) {
    if (!shortCut)
        return "";
    let builder = "[";
    if (shortCut.useAlt)
        builder += "Alt + ";
    if (shortCut.useCtrl)
        builder += "Ctrl + ";
    if (shortCut.useShift)
        builder += "Shift + ";
    if (shortCut.theKey.length > 2)
        builder += translateId(shortCut.theKey);
    else
        builder += shortCut.theKey;
    builder += "]";
    return builder;
}

export function getFunctionShortCut(_function) {
    return reversedShortcuts.get(_function);
}

export function isKeyEventForBusinessFunction(eOrKey, id) {
    let shortcuts = findBusinessIdsForEvent(eOrKey);
    if (!shortcuts)
        return false;
    return shortcuts.contains(id);
}

export function findBusinessIdsForEvent(eOrKey) {
    if (!(eOrKey instanceof String || typeof eOrKey === 'string')) {
        eOrKey = eventKey(eOrKey.keyCode, eOrKey.altKey, eOrKey.ctrlKey, eOrKey.shiftKey)
    }
    return registeredShortcuts.get(eOrKey);
}